import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { fuseAnimations } from '@fuse/animations';
import { lang_emailhistory } from 'app/idiomas/i18n/emailhistory/emailhistory.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { EmailHistoryTableService, } from "../email-history-table.service";

interface producto {
  name: string;
  id?: number;
  anioProducto?: string;
  datosProducto?: any;
  acumulable?: boolean;
  consecutivo?: boolean;
  children?: producto[];
}

interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  id?: number;
  anioProducto?: string;
  acumulable?: boolean;
  consecutivo?: boolean;
  datosProducto?: any;
}

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations   : fuseAnimations
})
export class MenuComponent implements OnInit {

  @Output() cierraMenu: EventEmitter<any> = new EventEmitter();
  @Output() enviaProducto: EventEmitter<any> = new EventEmitter();

  private _transformer = (node: producto, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      id: node.id,
      anioProducto: node.anioProducto,
      acumulable: node.acumulable,
      consecutivo: node.consecutivo,
      datosProducto: node.datosProducto,
    };
  }
  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  cargando = true;
  idEmpresa: string;
  productosEmpresa = [
    {
      name: 'Fruit',
      children: [
        {name: 'Apple'},
        {name: 'Banana'},
        {name: 'Fruit loops'},
      ]
    }, {
      name: 'Vegetables',
      children: [
        {
          name: 'Green',
          children: [
            {name: 'Broccoli'},
            {name: 'Brussel sprouts'},
          ]
        }, {
          name: 'Orange',
          children: [
            {name: 'Pumpkins'},
            {name: 'Carrots'},
          ]
        },
      ]
    },
  ];

  constructor(
    private activatedRoute : ActivatedRoute,
    private surveyServ: EmailHistoryTableService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
  ) {
    // this.dataSource.data = this.productosEmpresa;
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
    });

    lang_emailhistory.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }


  ngOnInit() {
    this.getProductos();
  }

  getProductos(){
    this.surveyServ.getProductos(this.idEmpresa).subscribe((respuesta:any) => {
      console.log("getProductos:",respuesta);
      //arreglo de productos certificar
      let arregloCertificar: any = {
        name: 'TITLE_PROD_CER',
        children: [
          { name: 'CER_V1', id: 1, children: [] },
          { name: 'CER_V2', id: 20, children: [] },
          { name: 'CER_V3', id: 40, children: [] },
        ]
      };
      respuesta.productosCertificar.forEach(producto => {
        let idxTipo = arregloCertificar.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloCertificar.children[idxTipo].children.push({
            name: 'Certificar',
            anioProducto: producto.fechaCertificar,
            datosProducto: producto
          });
        }
      });
      //arreglo de productos medir
      let arregloMedir: any = {
        name: 'TITLE_PROD_MEDIR',
        children: [
          { name: 'MED_V1', id: 2, tipo: 0, children: [] },
          { name: 'MED_V2', id: 11, tipo: 1, children: [] },
          { name: 'MED_V3', id: 12, tipo: 2, children: [] },
          { name: 'MED_V4', id: 13, tipo: 3, children: [] },
          { name: 'MED_V5', id: 14, tipo: 4, children: [] },
          { name: 'MED_V6', id: 15, tipo: 5, children: [] },
          { name: 'MED_V7', id: 16, tipo: 6, children: [] },
          { name: 'MED_V8', id: 41, tipo: 0, children: [] },
        ]
      };
      respuesta.productosCertificar.forEach(producto => {
        let idxTipo = arregloMedir.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloMedir.children[idxTipo].children.push({
            name: 'Medir',
            anioProducto: producto.fechaCertificar,
            datosProducto: producto
          });
        }
      });
      respuesta.productosMedir.forEach(producto => {
        arregloMedir.children[0].children.push({
          name: 'Medir',
          anioProducto: producto.fechaMedir,
          datosProducto: producto
        });
      });
      respuesta.productosMedir2.forEach(producto => {
        let idxTipo = arregloMedir.children.findIndex(item => item.tipo == producto.tipo);
        if(idxTipo != -1){
          arregloMedir.children[idxTipo].children.push({
            name: 'Medir',
            anioProducto: producto.fechaProducto,
            datosProducto: producto
          });
        }
      });
      //arreglo de productos pulse
      let arregloPulse: any = {
        name: 'TITLE_PROD_PULSE',
        children: [
          { name: 'PULS_V1', id: 4, children: [] },
          { name: 'PULS_V3', id: 42, children: [] },
        ]
      };
      respuesta.productosCertificar.forEach(producto => {
        let idxTipo = arregloPulse.children.findIndex(item => item.id == producto.idProducto);
        if(idxTipo != -1){
          arregloPulse.children[idxTipo].children.push({
            name: 'Pulse',
            anioProducto: producto.fechaCertificar,
            acumulable: true,
            consecutivo: true,
            datosProducto: producto
          });
        }
      });
      respuesta.productosPulseCheck.forEach(producto => {
        arregloPulse.children[0].children.push({
          name: 'Pulse',
          anioProducto: producto.fechaPulseCheck,
          datosProducto: producto
        });
      });
      arregloPulse.children.forEach(tipoProd => {
        let arregloAniosPulse: any = [];
        tipoProd.children.forEach(prodIndiv => {
          let arbolAnio = arregloAniosPulse.find(item => item.name == prodIndiv.anioProducto);
          if(arbolAnio == undefined){
            arregloAniosPulse.push({
              name: prodIndiv.anioProducto.toString(),
              children: [prodIndiv]
            });
          } else{
            arbolAnio.children.push(prodIndiv);
          }
        });
        tipoProd.children = arregloAniosPulse;
      });

      //arreglo de productos focus
      let arregloFocus: any = {
        name: 'TITLE_PROD_FOCU',
        children: [
          // { name: 'v1', id: 43, children: [] },
        ]
      };
      respuesta.productosCertificar.forEach(producto => {
        if(producto.idProducto == 43){
          arregloFocus.children.push({
            name: 'Focus',
            anioProducto: producto.fechaCertificar,
            acumulable: true,
            datosProducto: producto
          });
        }
      });
      let arregloAniosFocus: any = [];
      arregloFocus.children.forEach(tipoProd => {
        // tipoProd.children.forEach(prodIndiv => {
          let arbolAnio = arregloAniosFocus.find(item => item.name == tipoProd.anioProducto);
          if(arbolAnio == undefined){
            arregloAniosFocus.push({
              name: tipoProd.anioProducto.toString(),
              children: [tipoProd]
            });
          } else{
            arbolAnio.children.push(tipoProd);
          }
        // });
      });
      arregloAniosFocus.forEach(arrAnio => {
        arrAnio.children.sort( (a,b) => {
          if(a.datosProducto.numPulse > b.datosProducto.numPulse){ return 1; } else{ return -1; }
        });
      });
      // tipoProd.children = arregloAniosFocus;
      arregloFocus.children = arregloAniosFocus;

      //arreglo de productos nom35
      let arregloNOM35: any = {
        name: 'TITLE_PROD_NORM',
        children: []
      };
      respuesta.productosNorma35.forEach(producto => {
        arregloNOM35.children.push({
          name: 'nom35',
          anioProducto: producto.fechaNorma35,
          datosProducto: producto
        });
      });

      //arreglo de productos cgo express
      let arregloCGOX: any = {
        name: 'TITLE_PROD_CGO_EXPRES',
        children: []
      };
      respuesta.productosCGOExpress.forEach(producto => {
        arregloCGOX.children.push({
          name: 'CGOExpress',
          anioProducto: producto.date,
          datosProducto: producto
        });
      });
      arregloCGOX.children.sort( (a,b) => {
        if(a.datosProducto.date > b.datosProducto.date){ return 1; } else{ return -1; }
      });

      let arbolProductos = [arregloCertificar,arregloMedir,arregloPulse,arregloFocus,arregloNOM35,arregloCGOX];
      console.log("arbol:",arbolProductos);
      let arbolDepurado = this.depuraArregloProducto(JSON.parse(JSON.stringify(arbolProductos)));
      console.log("depurado:",arbolDepurado);

      this.dataSource.data = arbolDepurado;
      this.cargando = false;
    });
  }

  depuraArregloProducto(arreglo:any){
    let arregloDepurado: any = [];
    arreglo.forEach((tipoProd,i) => {
      if(tipoProd.hasOwnProperty('children')){
        if(tipoProd.children.length > 0){
          tipoProd.children = this.depuraArregloProducto(tipoProd.children);
          if(tipoProd.children.length > 0){
            arregloDepurado.push(tipoProd);
          }
        }
      } else if(tipoProd.hasOwnProperty('datosProducto')){
        arregloDepurado.push(tipoProd);
      }
    });
    return arregloDepurado;
  }

  eligeProducto(producto:any){
    console.log("productoElegido:",producto);
    this.enviaProducto.emit(producto);
    this.cerrar();
  }

  cerrar(){
    this.cierraMenu.emit(true);
  }

}
